var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowForm)?_c('worker-personal-data-form',{on:{"on-save-success":_vm.onSaveSuccess,"on-is-form-valid":_vm.onIsFormValid,"update-personal-data":_vm.updatePersonalData}}):(_vm.shouldShowView)?_c('worker-personal-data-view'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }